























import { Component } from 'vue-property-decorator';
import PluginComponent from '../PluginComponent';
import { EventBus, EVENTS } from '@/services/EventBus';
import LayerConfig from '@/models/map-context/LayerConfig';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import sanitizeHtml from 'sanitize-html';
import Filter from '@/models/map-context/filter/Filter';

@Component<FeatureInfosPanelCustom>({
  props: {

  },
  components: {

  },
})

export default class FeatureInfosPanelCustom extends PluginComponent {
  static ID='FeatureInfosPanelCustom';

  static NAME='FeatureInfosPanelCustom';

  private currentFeature:any;

  isFeatureSelected = false;

  idoc=51;

  public keys = Array<any>();

  public lstDocuments= Array<any>();

  plugins: Plugin[] = [];

  public layerOfFeature: LayerConfig|null=null;

  public edition = false;

  public width = 0;


  public urlApi="";
  public urlMetier="";


  public serviceApi="";

  public serviceApiEdit="";

  public infosContent = '';

  public keysForEdition = Array<any>();

  public isAccordionOpen: boolean = false;


  public isDocument: boolean=false;

  openOnSelectedFeature(features:any):boolean{

    console.log('oooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooo');
    this.currentFeature = features[0];
    if (this.getValue('id_document') || this.getValue('id_projet') || this.getValue('id_contrat') || this.getValue('id_alerte') || this.getValue('id_objectif') || this.getValue('id_element_projet')){
      return true;
    }
    return false;

  }




  beforeDestroy():void {
    EventBus.$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    EventBus.$off(EVENTS.CHANGE_FEATURE, this.onChangeFeature);
  }

  created() {
  }

  mounted() {

    this.lstDocuments=[];
    const plugin = this.pluginService.getByName(FeatureInfosPanelCustom.NAME); //FeatureInfosPanelCustom
    if (plugin){
      this.urlApi = plugin.getParameterValue('urlApi');
      this.urlMetier = plugin.getParameterValue('urlMetier');
    }

    EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);

    EventBus.$on(EVENTS.CHANGE_FEATURE, this.onChangeFeature);


    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    const selectedFeatures2 = [this.getMapService().selectionService.currentFeature];

    if (selectedFeatures2 !== undefined) {
      this.onFeatureSelected(selectedFeatures2);
    }
    else{
      if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
    }

  }

  onChangeFeature(feature: any) {
    this.onFeatureSelected([feature]);
  }

  onFeatureSelected(features: any) {
    console.log("onFeatureSelected2qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
    this.currentFeature = features[0];
      this.isFeatureSelected = true;

      if (this.getValue('id_document')){
      this.isDocument=true;
      this.serviceApi=this.urlApi + "documents/" + this.getValue('id_document');
      this.serviceApiEdit=this.urlMetier + "documents/" + this.getValue('id_document') + "/view";
    }
    else{


      this.isDocument=false;
      if (this.getValue('id_projet') || this.getValue('id_contrat') || this.getValue('id_alerte') || this.getValue('id_objectif') || this.getValue('id_element_projet')){
        if (this.getValue('id_projet')){
          this.serviceApi=this.urlApi + "projets/" + this.getValue('id_projet') + "/documents/";
          this.serviceApiEdit=this.urlMetier + "projets/" + this.getValue('id_projet') + "/view/";
        }
        if (this.getValue('id_contrat')){
          this.serviceApi=this.urlApi + "contrats/" + this.getValue('id_contrat') + "/documents/";
          this.serviceApiEdit=this.urlMetier + "contrats/" + this.getValue('id_contrat') + "/view/";
        }
        if (this.getValue('id_alerte')){
          this.serviceApi=this.urlApi + "alertes/" + this.getValue('id_alerte') + "/documents/";
          this.serviceApiEdit=this.urlMetier + "alertes/" + this.getValue('id_alerte') + "/view/";
        }
        if (this.getValue('id_objectif')){
          this.serviceApi=this.urlApi + "objectifs/" + this.getValue('id_objectif') + "/documents/";
          this.serviceApiEdit=this.urlMetier + "objectifs/" + this.getValue('id_objectif') + "/view/";
        }
        if (this.getValue('id_element_projet')){
          this.serviceApi=this.urlApi + "elementprojets/" + this.getValue('id_element_projet') + "/documents/";
          this.serviceApiEdit=this.urlMetier + "elementprojets/" + this.getValue('id_element_projet') + "/view/";
        }
      }

    }

    this.getDocuments();
      //this.getMapService().selectionService.addToSelection(this.currentFeature);

      //this.parseFeature();
    }



  //   parseFeature() {
  //     if (this.currentFeature) {


  //       if (this.currentFeature) {
  //         this.layerOfFeature = this.currentFeature.layerConfig;
  //         if (this.layerOfFeature && this.layerOfFeature.editing) {
  //           this.edition = true;
  //         }
  //         if (this.layerOfFeature && this.layerOfFeature.ficheInfos.width && this.layerOfFeature.ficheInfos.width>=20 && this.layerOfFeature.ficheInfos.width<=100) {
  //           this.width = this.layerOfFeature.ficheInfos.width;
  //         } else {
  //           this.width = 0;
  //         }

  //         this.infosContent ='';

  //         if (this.layerOfFeature && this.layerOfFeature.ficheInfos.active) {
  //           const regEx = new RegExp(/{(.*?)}/, 'ig');
  //           let feature=this.currentFeature;
  //           let infosContent =(<string>this.layerOfFeature.ficheInfos.content).replace(regEx, (a:any, b:any) => {
  //             let value = feature ? Filter.evaluateExpression(b, feature.getProperties()) : null;

  //             //if value is a number with lots of decimals, truncate to 3 redmine #21755
  //             if(!isNaN(parseFloat(value)) && isFinite(value)){
  //               value=parseFloat(value);
  //               if( (value+"").indexOf('.')>0){
  //                 let nbDecimale = (value+"").split(".")[1].length;
  //                 if(nbDecimale>5){
  //                   value=Math.round(value*1000)/1000;
  //                 }
  //               }

  //             }

  //             return value != undefined ? value : '';
  //           });
  //           infosContent = sanitizeHtml(infosContent,{
  //             allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'img' ]),
  //             allowedAttributes: false,
  //             allowedSchemesByTag: {
  //               img: [ 'data','https' ]
  //             }
  //           });
  //           this.infosContent = infosContent;// "<div class='ck-content'>"+popupinfosContent+'</div>';
  //         }
  //       }

  //       let allkeys = [];

  //       if (this.currentFeature.getKeys) {
  //         allkeys = this.currentFeature.getKeys();
  //       } else {
  //         const props = this.currentFeature.getProperties();
  //         for (const p in props) {
  //           allkeys.push(p);
  //         }
  //       }

  //       this.keys = Array<any>();

  //       const self = this;
  //       if (this.layerOfFeature && this.layerOfFeature.layerProperties
  //           && this.layerOfFeature.layerProperties.length > 0) {
  //         const layerProperties = this.layerOfFeature.layerProperties;
  //         this.keysForEdition = layerProperties.filter((x:LayerAttribute): any => x.name !== this.currentFeature.geometryName_ && x.editable);
  //         const cf = this.currentFeature;
  //         this.keysForEdition.forEach((key:any) => {
  //           key.value = self.getValue(key.name);
  //         });
  //         // On sélectionne les clefs d'attributs qu'on veut afficher
  //         allkeys.forEach((key:any): void => {
  //           if (self.shallDisplayKey(key, layerProperties) && self.getValue(key) !== undefined) {
  //             self.keys.push(key);
  //           }
  //         });
  //       } else {
  //         // On en prend que les key dont la valeur existe réellement.
  //         allkeys.forEach((key:any) => {
  //           if (self.getValue(key)) {
  //             self.keys.push(key);
  //           }
  //         });
  //       }

  //       // On retire la géométrie des attributs à montrer
  //       const geomName = this.currentFeature.geometryName_;
  //       if (this.keys.indexOf(geomName) >= 0) {
  //         this.keys.splice(this.keys.indexOf(geomName), 1);
  //       }
  //       const target:any = this.$refs.customContent;
  //       if (this.layerOfFeature && (<any>this.layerOfFeature).featureInfoContentRenderer) {
  //         // eslint-disable-next-line no-unused-expressions
  //         this.layerOfFeature!.featureInfoContentRenderer(self.currentFeature, target);
  //       }
  //     } else {
  //       // reset le panneau de moficiation
  //       this.currentFeature = null;
  //       this.layerOfFeature = null;
  //       this.isFeatureSelected = false;
  //     }

  // }


  getDocuments(){

    var that=this;
    var xmlhttp = new XMLHttpRequest();
    var url = "myTutorials.txt";
    this.lstDocuments =[];
    xmlhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {

          console.log(this.responseText.split('!DOCTYPE'));
          console.log(this.responseText.split('!DOCTYPE').length);

          if (this.responseText.split('!DOCTYPE').length==1){


            var val=JSON.parse(this.responseText);

            if (val){
              if (val.idDocument){
              that.lstDocuments=[val];
              }
              else{
                if (val!=undefined){
                  that.lstDocuments = val;
                }
              }
            }



            // if (that.lstDocuments){
            //   if (that.lstDocuments.idDocument){
            //   that.lstDocuments=[that.lstDocuments];
            //   }
            // }

          }

          if (that.lstDocuments==undefined){
              that.lstDocuments=[];
            }

        }
    };
    xmlhttp.open("GET", this.serviceApi, false);
    xmlhttp.send();
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    console.log(this.serviceApi);
  }




  // getLabel(key:any) {
  //   if (this.layerOfFeature && this.layerOfFeature.layerProperties) {
  //     const searchAttribute = this.layerOfFeature.layerProperties.filter((data) => data.name === key)[0];
  //     if (searchAttribute !== undefined && searchAttribute.label !== undefined && searchAttribute.label !== '') {
  //       return searchAttribute.label;
  //     }
  //   }

  //   return key;
  // }

  openInNewTab(url: string) {
    if(url){
      window.open(url, '_blank');
    }
  }

  getValue(key:any) {
    // Cesium Entity
    if (this.currentFeature.properties) {
      return this.currentFeature.properties.getValue()[key];
    }
    if (this.currentFeature.get(key) === undefined) {
      return '';
    }
    return this.currentFeature.get(key);
  }

  shallDisplayKey(key:string, properties:any) {
    return properties.filter((el:any) => key === el.name && el.display).length > 0;
  }
  getDocUrl(doc:any) {
    console.log("fffffffffffffffffffffffffffffffffffffffffffffffffffff");

    console.log(doc);
    console.log(doc.idDocument);
    return this.urlApi + "documents/" + doc.idDocument + "/file";
  }

  getDocName(doc:any) {
    return doc.cheminStockage;
  }

  open(){
    this.openInNewTab(this.serviceApiEdit);
  }




}
